import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "datesContainer"]
  
  connect() {
    console.log("Sanction selection controller connected")
    this.updateAllContainers()
  }
  
  toggleSanction(event) {
    const checkbox = event.target
    const sanctionId = checkbox.dataset.sanctionId
    const isChecked = checkbox.checked
    
    console.log(`Sanction ${sanctionId} ${isChecked ? 'selected' : 'deselected'}`)
    
    this.updateContainersForSanction(sanctionId, isChecked)
  }
  
  updateContainersForSanction(sanctionId, isVisible) {
    // Mettre à jour les conteneurs de dates
    this.datesContainerTargets.forEach(container => {
      if (container.dataset.sanctionId === sanctionId) {
        if (isVisible) {
          container.classList.remove('hidden')
        } else {
          container.classList.add('hidden')
          // Vider les champs de date quand on désélectionne
          this.clearDateFields(container)
        }
      }
    })
  }
  
  updateAllContainers() {
    this.checkboxTargets.forEach(checkbox => {
      const sanctionId = checkbox.dataset.sanctionId
      const isChecked = checkbox.checked
      this.updateContainersForSanction(sanctionId, isChecked)
    })
  }
  
  clearDateFields(container) {
    // Flatpickr text fields, not native date inputs.
    container.querySelectorAll('input').forEach(input => {
      if (input._flatpickr) input._flatpickr.clear()
      else input.value = ''
    })
  }
} 